/**
 * Grid item video play/pause. Loaded from sections/grid.liquid as type="module".
 */

if (!customElements.get('video-control')) {
  customElements.define(
    'video-control',
    class VideoControl extends HTMLElement {
      constructor() {
        super()
        const videos = Array.from(this.querySelectorAll('.js-video'))
        const button = this.querySelector('.js-button-video')
        if (!videos.length || !button) return
        button.addEventListener('click', (e) => {
          e.preventDefault()
          const paused = videos[0].paused
          videos.forEach((video) => {
            if (paused) video.play()?.catch(() => {})
            else video.pause()
          })
          button.classList.toggle('played', paused)
        })
      }
    }
  )
}
